import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import glamorous from 'glamorous'


const Item = muiThemeable()(
  glamorous.a(
    ({
      length,
      first,
      muiTheme: {
        palette: {
          borderColor,
        },
      },
    }) => ({
      padding: '0 15px 0 15px',
      display: 'inline-block',
      borderLeft: `${first ? '0px' : '0.8px'} solid ${borderColor}`,
      fontSize: 20,
    }),
    ({
      isActive,
      muiTheme: {
        palette: {
          accent1Color,
          accent2Color,
        },
      },
    }) => ({
      backgroundColor: accent2Color,
    }),
  ),
)

const TextStyle = muiThemeable()(
  glamorous.span(
    ({
      muiTheme: {
        palette: {
          accent2Color,
        },
      },
    }) => ({
    }),
    ({
      isActive,
      muiTheme: {
        palette: {
          primary1Color,
          accent1Color,
          accent3Color,
          alternateTextColor,
        },
      },
    }) => ({
      color: isActive ? accent1Color : accent3Color,
      fontSize: 16,
      fontWeight: 'bold',
    }),
  ),
)

const TabElementD = ({
  onTouchTap,
  isActive,
  tabLabel,
  first,
  length,
}) => (
  <Item
    isActive={isActive}
    onClick={onTouchTap}
    length={length}
    first={first}
  >
    <TextStyle as="span" isActive={isActive}>
      {tabLabel}
    </TextStyle>
  </Item>
)

TabElementD.propTypes = {
  onTouchTap: PropTypes.func,
  isActive: PropTypes.bool,
  tabLabel: PropTypes.string,
  length: PropTypes.number,
  first: PropTypes.bool,
}
TabElementD.defaultProps = {
  onTouchTap: () => {},
  isActive: false,
  tabLabel: '',
  length: 1,
  first: false,
}

export default TabElementD



// WEBPACK FOOTER //
// ./src/components/Tabs/ElementTabs/ElementTabE.js